import { CiLocationOn } from "react-icons/ci";
import {
  FaFacebookSquare,
  FaYoutube,
  FaPinterestP,
  FaInstagramSquare,
  FaLinkedin,
  FaTiktok,
  FaCartPlus,
  FaRegHeart,
  FaRegUser,
} from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import men_1 from "../assets/men-1.png";
import men_2 from "../assets/men-2.png";
import men_3 from "../assets/men-3.png";
import men_4 from "../assets/men-4.png";
import men_5 from "../assets/men-5.png";

export const navLinks = [
  {
    id: 1,
    tilte: "Home",
    link: `/`,
  },
  {
    id: 2,
    tilte: "Women’s Fragrances",
    link: `/fragrance?category=women`,

    sublink: [
      {
        id: 1,
        title: "Category",
        itms: [
          {
            id: 1,
            title: "All Perfumes",
            link: "/fragrance?category=women",
          },
          {
            id: 2,
            title: "Testers",
            link: "/fragrance?category=women",
          },
        ],
      },
      {
        id: 2,
        title: "More Ways to Shop",
        itms: [
          {
            id: 1,
            title: "New Arrivals",
            link: "/fragrance?category=women",
          },
          {
            id: 2,
            title: "Top Selles",
            link: "/fragrance?category=women",
          },
          {
            id: 3,
            title: "Featured Products",
            link: "/fragrance?category=women",
          },
        ],
      },
      {
        id: 2,
        title: "Popular Perfumes",
        itms: [
          {
            id: 1,
            title: "Bvlgari",
            link: "/fragrance?category=women&vendor=Bvlgari",
          },
          {
            id: 2,
            title: "Dana",
            link: "/fragrance?category=women&vendor=Christian",
          },
          {
            id: 3,
            title: "Burberry",
            link: "/fragrance?category=women&vendor=Burberry",
          },
          {
            id: 4,
            title: "Gucci",
            link: "/fragrance?category=women&vendor=Armaf",
          },
          {
            id: 5,
            title: "Calvin klein",
            link: "/fragrance?category=women&vendor=Calvin",
          },
          {
            id: 6,
            title: "View All",
            link: "/fragrance?category=women",
          },
        ],
      },
    ],
  },
  {
    id: 3,
    tilte: "Men’s Fragrances",
    link: `/fragrance?category=men`,

    sublink: [
      {
        id: 1,
        title: "Category",
        itms: [
          {
            id: 1,
            title: "All Fragrances",
            link: "/fragrance?category=men",
          },
          {
            id: 2,
            title: "Testers",
            link: "/fragrance?category=men",
          },
        ],
      },
      {
        id: 2,
        title: "More Ways to Shop",
        itms: [
          {
            id: 1,
            title: "New Arrivals",
            link: "/fragrance?category=men",
          },
          {
            id: 2,
            title: "Top Selles",
            link: "/fragrance?category=men",
          },
          {
            id: 3,
            title: "Featured Products",
            link: "/fragrance?category=men",
          },
        ],
      },
      {
        id: 2,
        title: "Popular Perfumes",
        itms: [
          {
            id: 1,
            title: "Bvlgari",
            link: "/fragrance?category=men&vendor=Bvlgari",
          },
          {
            id: 2,
            title: "Dana",
            link: "/fragrance?category=men&vendor=Christian",
          },
          {
            id: 3,
            title: "Burberry",
            link: "/fragrance?category=men&vendor=Burberry",
          },
          {
            id: 4,
            title: "Gucci",
            link: "/fragrance?category=men&vendor=Armaf",
          },
          {
            id: 5,
            title: "Calvin klein",
            link: "/fragrance?category=men&vendor=Calvin",
          },
          {
            id: 6,
            title: "View All",
            link: "/fragrance?category=men",
          },
        ],
      },
    ],
  },

  {
    id: 4,
    tilte: "Gift Sets",
    link: `/fragrance?category=gifts`,
    sublink: [
      {
        id: 1,
        title: "Men's Gift set",
        link: "/",
      },
      {
        id: 2,
        title: "Women's Gift Set",
        link: "/",
      },
    ],
  },
  {
    id: 5,
    tilte: "New Year Sale 2026",
    link: `/fragrance?category=new_year_sale`,
  },
  {
    id: 6,
    tilte: "Unisex",
    link: `/fragrance?category=unisex`,
  },
  {
    id: 7,
    tilte: "Best Sellers",
    link: `/fragrance?tags=Best%20Sales,Top%20Sellers,bestseller`,
  },
  {
    id: 8,
    tilte: "Didn’t Find Your Perfume?",
    link: "/contact",
  },
];

export const customer_service = [
  {
    id: 1,
    title: "About Us",
    link: "/about",
  },
  {
    id: 2,
    title: "Shipping Information",
    link: "/shipping",
  },
  {
    id: 3,
    title: "Privacy Policy",
    link: "/privacy_policy",
  },
  {
    id: 4,
    title: "Return Policy",
    link: "/return_policy",
  },
  {
    id: 5,
    title: "Sitemap",
    link: "/sitemap",
  },
  {
    id: 6,
    title: "Unsubscribe Newsletter",
    link: "/newsletter",
  },
  {
    id: 7,
    title: "Blog",
    link: "/blog",
  },
  {
    id: 8,
    title: "Damage Or Defective Product Policy",
    link: "/damage",
  },
  {
    id: 9,
    title: "Reward Points Policy",
    link: "/rewards",
  },
];

export const more_links = [
  {
    id: 1,
    title: "Best Sellers",
    link: "/fragrance?tags=Best%20Sales,Top%20Sellers,bestseller",
  },
  {
    id: 2,
    title: "Fragrances Faq's",
    link: "/faqs",
  },
  {
    id: 3,
    title: "My Account",
    link: "/user",
  },
  {
    id: 4,
    title: "My Cart",
    link: "/cart",
  },
  {
    id: 5,
    title: "Wishlist",
    link: "/user/favorite",
  },
  {
    id: 6,
    title: "Track Your Order",
    link: "/track_order",
  },
  {
    id: 7,
    title: "Wholesale Information",
    link: "/wholesale_information",
  },
  {
    id: 8,
    title: "How To Apply Fragrance",
    link: "/damage",
  },
  {
    id: 9,
    title: "Didn't find your perfume?",
    link: "/contact",
  },
];

export const social = [
  {
    id: 1,
    title: "Facebook",
    icon: FaFacebookSquare,
    link: "/facebook",
  },
  {
    id: 2,
    title: "X",
    icon: FaXTwitter,
    link: "/x",
  },
  {
    id: 3,
    title: "Pinterest",
    icon: FaPinterestP,
    link: "/pinterest",
  },
  {
    id: 4,
    title: "Youtube",
    icon: FaYoutube,
    link: "/youtube",
  },
  {
    id: 5,
    title: "LinkedIn",
    icon: FaLinkedin,
    link: "/linkedin",
  },
  {
    id: 6,
    title: "Instagram",
    icon: FaInstagramSquare,
    link: "/instagram",
  },
  {
    id: 7,
    title: "Ticktok",
    icon: FaTiktok,
    link: "/ticktok",
  },
];

export const testimonial = [
  {
    id: 1,
    name: "Sophia Reynolds",
    detail:
      "Absolutely in love with the fragrance! The scent lasts all day without being overpowering. The packaging felt luxurious and premium. I’ll definitely be ordering again.",
  },
  {
    id: 2,
    name: "Daniel Carter",
    detail:
      "The perfume exceeded my expectations. Smooth notes, long-lasting performance, and fast delivery. Customer service was also very responsive and helpful.",
  },
  {
    id: 3,
    name: "Olivia Bennett",
    detail:
      "I bought this as a gift for my sister and she adored it. The fragrance feels elegant and unique compared to other brands. Highly recommended!",
  },
  {
    id: 4,
    name: "James Holloway",
    detail:
      "Great quality scent with impressive longevity. The bottle design is classy and looks amazing on my shelf. Worth every penny.",
  },
  {
    id: 5,
    name: "Isabella Morgan",
    detail:
      "The aroma is soft yet captivating. I receive compliments every time I wear it. Shipping was quick and the product arrived safely packaged.",
  },
  {
    id: 6,
    name: "Ethan Brooks",
    detail:
      "Very refined and masculine fragrance. It feels premium and stays noticeable throughout the evening. I’m really impressed with the craftsmanship.",
  },
  {
    id: 7,
    name: "Ava Thompson",
    detail:
      "This perfume has become my everyday signature scent. It’s fresh, elegant, and perfectly balanced. Customer support was friendly and professional.",
  },
  {
    id: 8,
    name: "Liam Harrison",
    detail:
      "The scent profile is rich and sophisticated. I appreciate the attention to detail in both fragrance and packaging. Delivery was on time as promised.",
  },
  {
    id: 9,
    name: "Mia Anderson",
    detail:
      "Beautifully blended fragrance with long-lasting freshness. It feels luxurious and special. I’m extremely satisfied with my purchase.",
  },
];

export const categoryData = [
  {
    title: "Men’s Fragrances",
    subtitle: "Fragrances",
    tag: "Men",
    description1:
      "Men’s Fragrances are designed to reflect strength, confidence, and sophistication.",
    description2:
      "From woody and spicy blends to fresh citrus and aquatic notes, these scents enhance personal style and leave a bold, lasting impression.",
    // image: men,
    helment: "Expensive Men Fragrances and Perfumes",
  },
  {
    title: "Women’s Fragrances",
    subtitle: "Fragrances",
    tag: "Women",
    description1:
      "Women’s Fragrances are thoughtfully crafted to express elegance.",
    description2:
      "Featuring floral, fruity, and warm notes, these perfumes complement every mood and occasion.",
    // image: women,
    helment: "Luxury Women Fragrances and Perfumes",
  },
  {
    title: "Unisex Fragrances",
    subtitle: "Fragrances",
    tag: "Unisex",
    description1:
      "Unisex Fragrances are versatile scents created for everyone.",
    description2:
      "Blending fresh, woody, citrus, and musky notes, these perfumes balance masculinity and femininity.",
    // image: unisex,
    helment: "Buy Unisex Perfume at Best Prices",
  },
  {
    title: "Gifts Fragrances",
    subtitle: "",
    tag: "Gifts",
    description1:
      "Our Gifts collection features thoughtfully curated items perfect for every occasion.",
    description2:
      "From elegant perfumes to stylish accessories, each gift is designed to delight and inspire.",
    // image: gift,
    helment: "Perfume Set Gifts & Perfume Set on Sales",
  },
  {
    title: "New Year Sales 2026",
    subtitle: "2026",
    tag: "new_year_sale",
    description1: "Celebrate the season with exclusive discounts.",
    description2:
      "Discover premium fragrances at special prices for a limited time only.",
    // image: sales,
    helment: "Buy Best New Sales Perfume",
  },
  {
    title: "Best Deals",
    subtitle: "",
    tag: "best_deals",
    description1: "Shop our most popular offers.",
    description2:
      "Enjoy unbeatable prices on top-selling fragrances loved by our customers.",
    // image: deals,
    helment: "Top Best Sellers - Popular Fragrances",
  },

  // --- 12 brands start here ---

  //   {
  //     title: "Versace",
  //     subtitle: "Fragrances",
  //     tag: "Versace",
  //     description1: "Experience the bold and stylish fragrances from Versace.",
  //     description2: "Perfect for those who love daring and distinctive scents.",
  //     image: versaceImg,
  //     helment: "Buy Versace - Discount Perfumes",
  //   },
  //   {
  //     title: "Christian Dior",
  //     subtitle: "Fragrances",
  //     tag: "Christian",
  //     description1:
  //       "Christian Dior fragrances exude luxury and timeless elegance.",
  //     description2: "From floral to woody notes, find your signature scent.",
  //     image: diorImg,
  //     helment: "Buy Christian Dior - Discount Perfumes",
  //   },
  //   {
  //     title: "Bvlgari",
  //     subtitle: "Fragrances",
  //     tag: "Bvlgari",
  //     description1: "Bvlgari perfumes embody refined Italian craftsmanship.",
  //     description2: "A perfect balance of luxury, elegance, and sensuality.",
  //     image: bvlgariImg,
  //     helment: "Buy Bvlgari - Discount Perfumes",
  //   },
  //   {
  //     title: "Calvin Klein",
  //     subtitle: "Fragrances",
  //     tag: "Calvin",
  //     description1: "Calvin Klein offers iconic fragrances loved worldwide.",
  //     description2: "Simple, modern, and unforgettable scents for everyone.",
  //     image: calvinImg,
  //     helment: "Buy Calvin Klein - Discount Perfumes",
  //   },
  //   {
  //     title: "Cartier",
  //     subtitle: "Fragrances",
  //     tag: "Cartier",
  //     description1: "Discover Cartier’s exclusive fragrance collections.",
  //     description2:
  //       "Luxury scents inspired by heritage, elegance, and innovation.",
  //     image: cartierImg,
  //     helment: "Buy Cartier - Discount Perfumes",
  //   },
  //   {
  //     title: "Armaf",
  //     subtitle: "Fragrances",
  //     tag: "Armaf",
  //     description1: "Armaf delivers affordable luxury in a fragrance bottle.",
  //     description2: "Vibrant and long-lasting scents for every occasion.",
  //     image: armafImg,
  //     helment: "Buy Armaf - Discount Perfumes",
  //   },
  //   {
  //     title: "Azzaro",
  //     subtitle: "Fragrances",
  //     tag: "Azzaro",
  //     description1: "Azzaro fragrances blend passion, energy, and elegance.",
  //     description2: "Timeless perfumes perfect for day or night wear.",
  //     image: azzaroImg,
  //     helment: "Buy Azzaro - Discount Perfumes",
  //   },
  //   {
  //     title: "Burberry",
  //     subtitle: "Fragrances",
  //     tag: "Burberry",
  //     description1: "Burberry fragrances reflect British elegance and style.",
  //     description2: "Sophisticated scents for men and women alike.",
  //     image: burberryImg,
  //     helment: "Buy Burberry - Discount Perfumes",
  //   },
  //   {
  //     title: "Carolina Herrera",
  //     subtitle: "Fragrances",
  //     tag: "Carolina",
  //     description1: "Carolina Herrera perfumes are classy, chic, and bold.",
  //     description2: "Celebrate sophistication and style with every spray.",
  //     image: chImg,
  //     helment: "Buy Carolina Herrera - Discount Perfumes",
  //   },
  //   {
  //     title: "Clinique",
  //     subtitle: "Fragrances",
  //     tag: "Clinique",
  //     description1: "Clinique fragrances are clean, fresh, and modern.",
  //     description2: "Subtle scents perfect for daily wear and office settings.",
  //     image: cliniqueImg,
  //     helment: "Buy Clinique - Discount Perfumes",
  //   },
  //   {
  //     title: "Adrienne Vittadini",
  //     subtitle: "Fragrances",
  //     tag: "Adrienne",
  //     description1: "Adrienne Vittadini offers stylish and elegant fragrances.",
  //     description2: "Express yourself with vibrant and feminine scents.",
  //     image: adrienneImg,
  //     helment: "Buy Adrienne Vittadini - Discount Perfumes",
  //   },
];

export const userProfile = [
  {
    id: 1,
    title: "Profile",
    icon: <FaRegUser />,
    link: "/user/profile",
  },
  {
    id: 2,
    title: "My Wish List",
    icon: <FaRegHeart />,
    link: "/user/favorite",
  },
  {
    id: 3,
    title: "Address Book",
    icon: <CiLocationOn />,
    link: "/user/address",
  },
  {
    id: 4,
    title: "Order History",
    icon: <FaCartPlus />,
    link: "/user/order_history",
  },
];

export const men = [
  {
    id: 1,
    title: "club de nuit milestone",
    perfumeBy: "ARMAF",
    type: ["106ml", "200ml"],
    price: 51.95,
    previous: 120.0,
    image: men_1,
  },
  {
    id: 2,
    title: "club de nuit milestone",
    perfumeBy: "ARMAF",
    type: ["106ml", "200ml"],
    price: 51.95,
    previous: 120.0,
    image: men_2,
  },
  {
    id: 3,
    title: "club de nuit milestone",
    perfumeBy: "ARMAF",
    type: ["106ml", "200ml"],
    price: 51.95,
    previous: 120.0,
    image: men_3,
  },
  {
    id: 4,
    title: "club de nuit milestone",
    perfumeBy: "ARMAF",
    type: ["106ml", "200ml"],
    price: 51.95,
    previous: 120.0,
    image: men_4,
  },
  {
    id: 5,
    title: "club de nuit milestone",
    perfumeBy: "ARMAF",
    type: ["106ml", "200ml"],
    price: 51.95,
    previous: 120.0,
    image: men_5,
  },
];
export const privacyPolicy = [
  {
    title: "BUSINESS INFORMATION",
    content: [
      "Gift of God Fragrances LLC",
      "1514 Azalea Dr",
      "North Brunswick Township, NJ 08902, USA",
      "Phone: (848) 667-0850",
      "Email: info@giftofgodfragrances.com",
      "Website: giftofgodfragrances.com",
    ],
  },
  {
    title: "INFORMATION WE COLLECT",
    content: [
      "We may collect the following personally identifiable information when voluntarily submitted:",
      "• Name",
      "• Email Address",
      "• Phone Number",
      "• Billing Address",
      "• Shipping Address",
      "• Payment Information (processed securely via third-party providers such as Stripe and PayPal)",
      "• Account login credentials (if you create an account)",
      "",
      "We collect this information when you:",
      "• Create an account",
      "• Place an order",
      "• Subscribe to our newsletter",
      "• Sign up for SMS marketing",
      "• Contact customer support",
      "",
      "We do not collect additional personal data beyond what is necessary to operate our e-commerce business.",
    ],
  },
  {
    title: "HOW WE USE YOUR INFORMATION",
    content: [
      "Your information may be used to:",
      "• Process and fulfill orders",
      "• Communicate order updates",
      "• Provide customer support",
      "• Send marketing emails (if you opt in)",
      "• Send SMS marketing messages (if you opt in)",
      "• Improve website functionality and customer experience",
      "• Prevent fraudulent transactions",
      "• Comply with legal obligations",
      "",
      "You may opt out of marketing communications at any time.",
    ],
  },
  {
    title: "PAYMENT PROCESSING",
    content: [
      "All payment transactions are processed securely through third-party payment processors such as Stripe and PayPal. We do not store or have direct access to your full credit card information.",
    ],
  },
  {
    title: "COOKIES & TRACKING TECHNOLOGIES",
    content: [
      "Our Website uses cookies and tracking technologies, including:",
      "• Meta (Facebook) Pixel",
      "• Website analytics tools",
      "",
      "These tools help us:",
      "• Analyze traffic and visitor behavior",
      "• Improve marketing performance",
      "• Enhance user experience",
      "",
      "Cookies do not collect personal information unless you voluntarily provide it. You can disable cookies through your browser settings.",
    ],
  },
  {
    title: "SMS & EMAIL MARKETING",
    content: [
      "If you opt in to receive SMS or email marketing:",
      "• You may receive promotional messages",
      "• Message frequency may vary",
      "• Standard carrier rates may apply for SMS",
      "",
      "You can unsubscribe at any time using the opt-out link in emails or replying STOP to SMS messages",
      "",
      "We do not sell or share your contact information for third-party marketing.",
    ],
  },
  {
    title: "SHARING OF INFORMATION",
    content: [
      "We may share your information only with:",
      "• Payment processors (Stripe, PayPal)",
      "• Shipping and logistics providers",
      "• Marketing and analytics service providers",
      "• Government agencies when required by law",
      "",
      "We do not sell personal information.",
    ],
  },
  {
    title: "DATA SECURITY",
    content: [
      "We implement reasonable security measures to protect your personal information. Only authorized personnel have access to sensitive data.",
      "",
      "While we take security seriously, no method of transmission over the Internet is 100% secure.",
    ],
  },
  {
    title: "YOUR RIGHTS",
    content: [
      "You may contact us at any time to:",
      "• Request access to your personal data",
      "• Correct inaccurate information",
      "• Request deletion of your information",
      "• Opt out of marketing communications",
      "• Express concerns about data usage",
      "",
      "Contact: info@giftofgodfragrances.com",
    ],
  },
  {
    title: "ADA COMPLIANCE",
    content: [
      "Our Website strives to maintain accessibility standards in accordance with ADA compliance guidelines to ensure equal access for all users.",
    ],
  },
  {
    title: "CHILDREN’S PRIVACY",
    content: [
      "Our Website is not intended for individuals under the age of 13. We do not knowingly collect personal information from children.",
    ],
  },
  {
    title: "CHANGES TO THIS POLICY",
    content: [
      "We reserve the right to update this Privacy Policy at any time. Changes will be posted on this page with the updated effective date.",
    ],
  },
];

export const returnsPolicy = [
  {
    title: "RETURNS",
    content: [
      "We accept returns within 30 days of receiving your order.",
      "",
      "To be eligible for a return:",
      "• Merchandise must be in its original condition",
      "• Items must be returned in their original packaging",
      "• Products must not be excessively used or damaged",
      "• A 15% restocking fee will be applied to any merchandise that has been opened.",
      "• Customers are responsible for return shipping costs. We recommend using a trackable shipping service.",
    ],
  },
  {
    title: "NON-REFUNDABLE SHIPPING",
    content: [
      "Shipping costs are non-refundable for:",
      "• Undelivered packages",
      "• Unclaimed packages",
      "• Refused packages",
      "• Returned shipments",
      "",
      "Unless the return is due to an error made by Gift of God Fragrances LLC, original shipping charges will not be refunded.",
    ],
  },
  {
    title: "RETURN REQUIREMENTS",
    content: [
      "To ensure your return is processed efficiently, please include:",
      "• Full Name",
      "• Order Number",
      "• Reason for Return",
      "",
      "All returns must include a valid tracking number.",
      "We are not responsible for returned packages until the tracking information confirms the package has been marked as “Delivered” to our facility.",
      "",
      "Once your return is received, please allow 4–5 business days for inspection and processing of your refund or exchange.",
      "Refunds will be issued to the original method of payment.",
    ],
  },
  {
    title: "RETURN ADDRESS",
    content: [
      "Returns should be sent to:",
      "",
      "Gift of God Fragrances LLC – Returns",
      "1514 Azalea Dr",
      "North Brunswick Township, NJ 08902",
      "USA",
    ],
  },
];
